var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-project-guests"},[(_vm.hasGuests)?_c('project-guests-table'):_vm._e(),_c('project-guests-add-existing'),_c('project-guests-invite-new',{attrs:{"mode":_vm.mode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }